/*@ngInject*/
const FormBuilderLeftNavController = function ($rootScope, $scope, $element, $stateParams, localization,
                                               formViewerConstant, formMediator, coreConstant,
                                               modalUtil, authorizationConstants, currentUserModel,
                                               formTemplateStatus, configurationMediator) {
    $element.addClass('formBuilderLeftNav');

    this.isSection = false;

    this.$onInit = function () {
        configurationMediator.getFormTemplateById($stateParams.uiFormTemplateId).then(function (formTemplateConfig) {
            this.formTemplateType = formTemplateConfig.formTemplate.type;
        }.bind(this));
    };

    localization.getTranslations().then(function (translations) {
        this.selectedField = null;
        this.insertComponentLabel = _.get(translations, 'formBuilderLeftNav.insertComponent');
        this.componentSettingsLabel = _.get(translations, 'formBuilderLeftNav.componentSettings');
        this.componentSettingsSubTextLabel = _.get(translations, 'formBuilderLeftNav.componentSettingsSubText');
        this.deleteComponentCustomIcon = null;

        this.areComponentSettingsActive = function () {
            return !_.isNil(this.selectedField);
        };

        this.componentSettingsDeleteButtonClicked = function () {
            var message = _.get(translations, 'componentEditor.deleteComponentConfirmation.summary'),
                title = _.get(translations, 'componentEditor.deleteComponentConfirmation.title'),
                cancelButtonLabel = _.get(translations, 'genericButtons.cancel'),
                confirmButtonLabel = _.get(translations, 'genericButtons.continue');

            function handleClose() {
                if (this.fieldStructure.repeating) {
                    formMediator.deleteRow(this.fieldStructure.rootFormId, this.fieldStructure.rowStructureId);
                } else {
                    formMediator.deleteField(this.fieldStructure.rootFormId, this.fieldStructure.fieldStructureId);
                }

                $rootScope.$broadcast(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, null);
            }

            modalUtil.showGenericConfirm({
                cancelButtonLabel: cancelButtonLabel,
                confirmActionButtonLabel: confirmButtonLabel,
                summary: message,
                title: title
            }).then(handleClose.bind(this));
        };

        this.insertComponentClicked = function () {
            $rootScope.$broadcast(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, null);
        };

        this.updateComponentSettings = function () {
            if (!_.isNil(this.selectedField)) {
                var userCanManageForms = currentUserModel.hasAuthorization(authorizationConstants.MANAGE_FORMS);

                    this.componentSettingsSubTextLabel = _.get(translations, 'componentSettings.fieldType.' + this.selectedField.fieldTemplate.type);
                    this.deleteComponentCustomIcon = null;
                    if (userCanManageForms) {
                        if (this.fieldStructure.parentFormStructure.uiFormTemplate.formTemplate.status === formTemplateStatus.IN_PRODUCTION) {
                            if (this.selectedField.id === -1) {
                                this.deleteComponentCustomIcon = 'glyphicon glyphicon-trash';
                            }
                        } else {
                            this.deleteComponentCustomIcon = 'glyphicon glyphicon-trash';
                        }
                    }
                    $rootScope.$broadcast(coreConstant.event.OPEN_ACCORDION_BUTTON, {value: 'componentSettings'});
                } else {
                    this.componentSettingsSubTextLabel = _.get(translations, 'formBuilderLeftNav.componentSettingsSubText');
                    this.deleteComponentCustomIcon = null;
                    $rootScope.$broadcast(coreConstant.event.CLOSE_ACCORDION_BUTTON, {value: 'componentSettings'});
                }
            };

        $scope.$on(coreConstant.event.COLLAPSIBLE_LEFT_NAV_OPENED, function () {
            $rootScope.$broadcast(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, null);
        });

        $scope.$on(coreConstant.event.COLLAPSIBLE_LEFT_NAV_CLOSED, function () {
            $rootScope.$broadcast(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, null);
        });

        $scope.$on(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, function (event, fieldStructure) {
            this.isSection = false;

            if (_.isNil(fieldStructure)) {
                this.selectedField = null;
            } else {
                this.selectedField = fieldStructure.uiField;
                this.fieldStructure = fieldStructure;
            }

            this.updateComponentSettings();
        }.bind(this));

        $scope.$on(formViewerConstant.configuration.event.CREATE_NEW_COMPONENT, function (event, newComponent) {
            this.isSection = false;

            this.selectedField = newComponent.fieldStructure.uiField;
            this.fieldStructure = newComponent.fieldStructure;

            this.updateComponentSettings();
            $rootScope.$broadcast(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, newComponent.fieldStructure);
        }.bind(this));


        $scope.$on(formViewerConstant.configuration.event.SECTION_SELECTION_CHANGE, function (event, sectionStructure) {
            this.selectedField = sectionStructure.sectionTemplate;
            this.fieldStructure = sectionStructure;
            this.componentSettingsSubTextLabel = _.get(translations, 'componentSettings.structureType.SECTION');
        }.bind(this));

        $scope.$on(formViewerConstant.configuration.event.ROW_SELECTION_CHANGE, function (event, rowStructure) {
            if(rowStructure.repeating) {
                this.selectedField = rowStructure.rowTemplate.repeaterField;
                this.fieldStructure = rowStructure;
            }
            else {
                this.selectedField = null;
                this.fieldStructure = null;
            }

            this.updateComponentSettings();

        }.bind(this));

        $scope.$on(formViewerConstant.configuration.event.DELETE_SECTION, function (event) {
            this.selectedField = null;
            this.fieldStructure = null;
            this.componentSettingsSubTextLabel = '';
        }.bind(this));

    }.bind(this));
};

angular.module('ums.configuration')
    .controller('formBuilderLeftNavController', FormBuilderLeftNavController);
